import {
  CLEAR_STAFF_LOG_POSTS,
  GET_STAFF_LOG_COMMENTS_LIST_SUCCESS,
  GET_STAFF_LOG_POSTS_SUCCESS,
  GET_STAFF_LOG_POST_SUCCESS,
  REMOVE_STAFF_LOG_COMMENT_SUCCESS,
  REMOVE_STAFF_LOG_POST_SUCCESS,
} from '../actionConstants';

const defaultState = {
  postsList: {},
};

export default (state = defaultState, action) => {
  const { type, res, isClearPrev, postId, isPostRemoval, commentId } = action;

  switch (type) {
    case GET_STAFF_LOG_POSTS_SUCCESS: {
      if (isClearPrev) {
        return { ...state, postsList: res?.data };
      }

      const prevResults = state?.postsList?.results || [];
      const newResults = res?.data?.results || [];
      const results = [...prevResults, ...newResults];

      const postsList = {
        ...res.data,
        results,
      };

      return { ...state, postsList };
    }

    case CLEAR_STAFF_LOG_POSTS:
      return { ...state, postsList: {} };

    case REMOVE_STAFF_LOG_POST_SUCCESS:
    case GET_STAFF_LOG_POST_SUCCESS: {
      const posts = Array.from(state.postsList.results || []);
      const postIndex = posts.findIndex(({ id }) => id === postId);

      if (postIndex === -1) return state;

      if (isPostRemoval) {
        posts.splice(postIndex, 1);
      } else {
        posts.splice(postIndex, 1, res.data);
      }

      return { ...state, postsList: { ...state.postsList, results: posts } };
    }

    case GET_STAFF_LOG_COMMENTS_LIST_SUCCESS: {
      const posts = Array.from(state.postsList.results || []);
      const postIndex = posts.findIndex(({ id }) => id === postId);
      if (postIndex === -1) return state;

      const { count, next, previous, results } = res?.data ?? {};
      const post = {
        ...posts[postIndex],
        commentsCount: count,
        olderComments: next,
        newerComments: previous,
        latestComments: results,
      };
      posts.splice(postIndex, 1, post);

      return { ...state, postsList: { ...state.postsList, results: posts } };
    }

    case REMOVE_STAFF_LOG_COMMENT_SUCCESS: {
      const posts = Array.from(state.postsList.results || []);
      const postIndex = posts.findIndex(({ id }) => id === postId);
      if (postIndex === -1) return state;

      const comments = Array.from(posts[postIndex].latestComments || []);
      const commentIndex = comments.findIndex(({ id }) => id === commentId);
      if (commentIndex === -1) return state;

      comments.splice(commentIndex, 1);
      const post = {
        ...posts[postIndex],
        commentsCount: posts[postIndex].commentsCount - 1,
        latestComments: comments,
      };
      posts.splice(postIndex, 1, post);

      return { ...state, postsList: { ...state.postsList, results: posts } };
    }

    default:
      return state;
  }
};
